import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useGetTracking } from '@cobliteam/hooks/src/useEntity/useTracking';
import Button from '@cobliteam/ui/components/Button';
import Dialog from '@cobliteam/ui/components/Dialog';
import Typography from '@cobliteam/ui/components/Typography';
import { TrackingMap } from '@cobliteam/ui-business/components';
import type { DriverOption } from '@cobliteam/ui-business/components/Selects/SelectDriver/SelectDriver';
import { endOfDay, startOfDay } from '@cobliteam/utils/date';
import DriverConfirmationSummary from './components/DriverConfirmationSummary';
import PathAddressDetails from './components/PathAddressDetails';

interface DriverConfirmationDialogProps {
  path: Path;
  open: boolean;
  newDriver?: DriverOption;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

const DriverConfirmationDialog = ({ path, open, onOpenChange, newDriver, onConfirm, onCancel }: DriverConfirmationDialogProps) => {
  const { startTime, endTime, vehicle } = path;

  const { data: tracking, isLoading: isTrackingLoading } = useGetTracking(vehicle?.id || '', startOfDay(startTime).getTime(), endOfDay(endTime).getTime(), true, {
    enabled: open && !!vehicle?.id,
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>{newDriver ? 'Associar motorista ao trecho' : 'Desassociar motorista do trecho'}</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close onClick={onCancel} />
        </Dialog.Header>
        <Dialog.Description className='sr-only' />
        <Dialog.Body className='flex-row gap-5'>
          <div className='flex flex-col gap-4'>
            <Typography variant='text-md' className='text-pretty'>
              {newDriver
                ? 'O motorista será associado ao trecho do veículo impactando relatórios e nota do Ranking de condução. Deseja confirmar a alteração?'
                : 'O motorista será desassociado do trecho do veículo impactando relatórios e nota do Ranking de condução. Deseja confirmar a alteração?'}
            </Typography>
            <div className='flex gap-7'>
              <div className='flex-1'>
                <TrackingMap tracking={tracking} pathWindow={{ start: startTime, end: endTime }} loading={isTrackingLoading} className='aspect-square h-full' />
              </div>
              <div className='flex flex-1 flex-col justify-between'>
                <PathAddressDetails path={path} />
                <DriverConfirmationSummary path={path} newDriver={newDriver} />
              </div>
            </div>
          </div>
        </Dialog.Body>
        <Dialog.Footer className='flex justify-end gap-2'>
          <Dialog.Close onClick={onCancel} asChild>
            <Button variant='ghost'>Cancelar</Button>
          </Dialog.Close>
          <Button onClick={onConfirm}>Confirmar</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default DriverConfirmationDialog;
